import React, { useEffect, useState } from "react";
import { Select, Spin } from "antd";
import useRequest from "../../hooks/useRequest";
import { ShowToast, Severty } from "../../helper/toast";
import apiPath from "../../constants/apiPath";
const { Option } = Select;

// When `options` is supplied the caller owns the list (e.g. options derived from
// the rows actually shown in a table); the component then skips its own fetch.
const BrandSelect = ({ value, onChange, categoryId, segmentId, options, optionsLoading = false }) => {

  const isControlledList = Array.isArray(options);

  const { request } = useRequest();
  const [brandList, setBrandList] = useState([]);
  const [loading, setLoading] = useState(false);

  const fetchBrands = async () => {
    setLoading(true);
    let url = apiPath.commonBrand;
    const params = [];
    if (categoryId) params.push(`category_id=${categoryId}`);
    if (segmentId) params.push(`segment_id=${segmentId}`);
    if (params.length) url += `?${params.join('&')}`;
    request({
      url,
      method: "GET",
      onSuccess: (res) => {
        const brands = res?.data?.data || [];
        setBrandList(brands);
        setLoading(false);
        if ((categoryId || segmentId) && value && !brands.some(b => b._id === value)) {
          onChange?.(undefined);
        }
      },
      onError: (err) => {
        setLoading(false);
        ShowToast(err?.response?.data?.message || "Failed to load brands", Severty.ERROR);
      },
    });
  }

  useEffect(() => {
    if (isControlledList) return;
    fetchBrands();
  }, [categoryId, segmentId, isControlledList]);

  const list = isControlledList ? options : brandList;
  const isLoading = isControlledList ? optionsLoading : loading;

  return (
    <Spin spinning={isLoading} tip="Loading brands..." size="small">
      <Select
        showSearch
        allowClear
        placeholder="Select brand"
        optionFilterProp="children"
        value={value}
        onChange={(val) => onChange?.(val)}
        disabled={false}
        loading={isLoading}
        filterOption={(input, option) =>
          option?.children?.toLowerCase().includes(input.toLowerCase())
        }
        className="w-full"
        style={{ height: 40 }}
      >
        {list?.map((item) => (
          <Option key={item._id} value={item._id}>
            {item.en_name}
          </Option>
        ))}
      </Select>
    </Spin>
  );
};

export default BrandSelect;
